const capitalize = (message: any) => {
  return typeof message === 'string'
    ? message.charAt(0).toUpperCase() + message.slice(1)
    : message;
};

export default capitalize;
